// TODO: Move this icon to @raydiant/raydial as a proper icon component
import { FC, SVGProps } from 'react';

interface ClockIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const ClockIcon: FC<ClockIconProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5 8.34375C14.5 6.03125 13.25 3.90625 11.25 2.71875C9.21875 1.5625 6.75 1.5625 4.75 2.71875C2.71875 3.90625 1.5 6.03125 1.5 8.34375C1.5 10.6875 2.71875 12.8125 4.75 14C6.75 15.1562 9.21875 15.1562 11.25 14C13.25 12.8125 14.5 10.6875 14.5 8.34375ZM0 8.34375C0 5.5 1.5 2.875 4 1.4375C6.46875 0 9.5 0 12 1.4375C14.4688 2.875 16 5.5 16 8.34375C16 11.2188 14.4688 13.8438 12 15.2812C9.5 16.7188 6.46875 16.7188 4 15.2812C1.5 13.8438 0 11.2188 0 8.34375ZM7.25 4.09375C7.25 3.6875 7.5625 3.34375 8 3.34375C8.40625 3.34375 8.75 3.6875 8.75 4.09375V7.96875L11.4062 9.71875C11.75 9.96875 11.8438 10.4375 11.625 10.7812C11.375 11.125 10.9062 11.2188 10.5625 10.9688L7.5625 8.96875C7.375 8.84375 7.25 8.59375 7.25 8.34375V4.09375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ClockIcon;
